import { useEffect, useState } from 'react';
import { Card, CardHeader } from '@mui/material';
import { collection, getCountFromServer } from 'firebase/firestore';
import { db } from '../../config/firebase';

const CardCollectionCount = ({ title, collectionName }) => {
  const [stateCount, setStateCount] = useState(0);
  const productsCollectionRef = collection(db, collectionName);

  useEffect(() => {
    const countOrder = async () => {
      const ordersSnapshot = await getCountFromServer(productsCollectionRef);
      setStateCount(ordersSnapshot?.data().count);
    };
    countOrder().then();
  }, [productsCollectionRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card>
      <CardHeader
        title={`Total ${title}`}
        subheader={stateCount}
        slotProps={{ subheader: { variant: 'h4', color: 'success' } }}
      />
    </Card>
  );
};

export default CardCollectionCount;
